import axios from "axios";
import { CONSTANTS, LOCAL_STORAGE } from '../common/constants';
const queryString = require('query-string');

class AuthService {

  login(Username: string, Password: string) {
    var data = queryString.stringify({
      'grant_type': 'password',
      'username': Username,
      'password': Password,
      'scope': 'offline_access api_hoc_hieu_qua' 
    });
    var config: any = {
      method: 'post',
      url: CONSTANTS.BASE_AUTH_API,
      headers: { 
        'Authorization': 'Basic bW9iaWxlX3N1bnNoaW5ldHZfYXBwX3Byb2Q6RldTdVlOWHluY2VjZDgyeA==', 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data : data
    };
    return axios(config);
  }

  isLoginSecret = (): boolean => {
    return (
      sessionStorage.getItem(CONSTANTS.SECRET_TOKEN) !== null
    );
  };

  isLogin = (): boolean => {
    return (
      localStorage.getItem(CONSTANTS.LOGIN_TOKEN) !== null
    );
  };

  roleTypeDataId = (): string => {
    const data = JSON.parse(localStorage.getItem(CONSTANTS.LOGIN_DATA) || '{}');
    return data?.roleTypeDataId || '--';
  };

  getAccountId = (): any => {
    const data = JSON.parse(localStorage.getItem(CONSTANTS.LOGIN_DATA) || '{}');
    return data?.id || '--';
  };

  getUserId = (): any => {
    const data = JSON.parse(localStorage.getItem(CONSTANTS.LOGIN_DATA) || '{}');
    return data?.userId || '--';
  };

  loginData = (): any => {
    return JSON.parse(localStorage.getItem(CONSTANTS.LOGIN_DATA) || '{}');
  };

  secretLogin(): any {
    var data = queryString.stringify({
      'grant_type': 'client_credentials',
      'scope': 'api_hoc_hieu_qua' 
    });
    var config: any = {
      method: 'post',
      url: CONSTANTS.BASE_AUTH_API,
      headers: { 
        'Authorization': 'Basic bW9iaWxlX3N1bnNoaW5ldHZfYXBwX3Byb2Q6RldTdVlOWHluY2VjZDgyeA==', 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data : data
    };
    return axios(config)
    .then((response: any) => {
      sessionStorage.setItem(CONSTANTS.SECRET_TOKEN, response.data.access_token)
      sessionStorage.setItem(CONSTANTS.SECRET_DATA, JSON.stringify(response.data));
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  logout() {
    localStorage.removeItem(CONSTANTS.LOGIN_TOKEN);
    localStorage.removeItem(CONSTANTS.LOGIN_DATA);
    localStorage.removeItem(LOCAL_STORAGE.ROLE);
    localStorage.removeItem(CONSTANTS.LOGIN_ROLES);
    localStorage.removeItem(LOCAL_STORAGE.MENU_ADMIN);
    localStorage.removeItem(LOCAL_STORAGE.MENU_USER);
  }
}

export default new AuthService();